let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3XbzG")).then(() => parcelRequire('4s2T0'));